__webpack_require__.p = "https://de.knowledgesearchcore.thomsonreuters.com/";